module.exports = new __parcel__URL__("kill-bill-vol-1.262efe85.jpg").toString();